import { useCallback } from "react";
import { Apis } from "../../lib/Apis";

const extractData = (response) => response?.data?.data ?? null;

export const useDashboardStats = () => {
  const getStats = useCallback(async (params = {}) => {
    try {
      const response = await Apis.getStats({
        period: "all",
        groupBy: "monthly",
        ...params,
      });
      return extractData(response);
    } catch (error) {
      console.error("Error fetching stats:", error);
      return null;
    }
  }, []);

  const getDesignsAnalytics = useCallback(async (params = {}) => {
    const response = await Apis.getDashboardDesigns(params);
    return extractData(response);
  }, []);

  const getInteriorDesignsAnalytics = useCallback(async (params = {}) => {
    const response = await Apis.getDashboardInteriorDesigns(params);
    return extractData(response);
  }, []);

  const getShopAnalytics = useCallback(async (params = {}) => {
    const response = await Apis.getDashboardShop(params);
    return extractData(response);
  }, []);

  const getBlogsAnalytics = useCallback(async (params = {}) => {
    const response = await Apis.getDashboardBlogs(params);
    return extractData(response);
  }, []);

  const getProjectsAnalytics = useCallback(async (params = {}) => {
    const response = await Apis.getDashboardProjects(params);
    return extractData(response);
  }, []);

  const getContractsAnalytics = useCallback(async (params = {}) => {
    const response = await Apis.getDashboardContracts(params);
    return extractData(response);
  }, []);

  const getPricingAnalytics = useCallback(async (params = {}) => {
    const response = await Apis.getDashboardPricing(params);
    return extractData(response);
  }, []);

  return {
    getStats,
    getDesignsAnalytics,
    getInteriorDesignsAnalytics,
    getShopAnalytics,
    getBlogsAnalytics,
    getProjectsAnalytics,
    getContractsAnalytics,
    getPricingAnalytics,
  };
};
